module.exports = __webpack_public_path__ + "static/media/PhoneTransaction.8bb7b816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PhoneTransaction.png
// module id = 747
// module chunks = 1 3